import { getAvailableLendersByLenderCommissions } from '__core/shared/util/salestrekker';
import template from './homeLoanCompareProducts.template.html';

export default {
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $mdMedia,
      $mdDialog,
      $timeout,
      eventService,
      authenticationService,
      dateTimeService,
      homeLoanService,
      helperService,
      quickToolService,
      organizationService,
      accountService,
      lendersService,
      liabilitiesService,
      ReviewProduct,
      ReviewProductSplit,
      CompareProduct,
      HomeLoanSearchProduct,
      Workflow,
      WorkflowType,
      ContactResidentialStatusOption,
      ContactEmploymentType,
      ContactEmploymentBasis,
      pdfService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.isAuthenticated = authenticationService.isAuthenticated();
      ctrl.hasBrokerToolsEnabled = false;

      ctrl.initialize = () => {
        ctrl.hasBrokerToolsEnabled = ctrl.isAuthenticated
          ? $rootScope.hasBrokerToolsEnabled()
          : false;

        ctrl.destroyWatch = eventService.onQuickToolHomeLoanCompareProducts((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {},
              template,
              controllerAs: '$ctrl',
              controller() {
                const ctr = this;
                ctr.isSplitSearch = false;
                ctr.activeSection = 'maximumBorrowing';
                ctr.isReady = false;
                ctr.isDownloadPreparing = false;
                ctr.isEnterprise = $rootScope.IsEnterprise;
                ctr.currentAccount = null;
                ctr.currentOrganization = $rootScope.CurrentOrganization;
                ctr.organizationCountry = helperService.getOrganizationCountry();
                ctr.hasBrokerToolsEnabled = $rootScope.hasBrokerToolsEnabled();
                ctr.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
                ctr.currentLocale = $rootScope.CurrentLocale();
                ctr.currentCurrency = $rootScope.CurrentCurrency();
                ctr.availableStates = helperService.getAvailableAddressStates();
                ctr.lenders = [];
                ctr.documents = [];
                ctr.reviewProducts = [];
                ctr.compareProducts = [];
                ctr.chosenProducts = [];
                ctr.searchFields = HomeLoanSearchProduct.Blank();
                ctr.lenderLogos = [];
                ctr.workflow = Workflow.build({
                  type: WorkflowType.of(WorkflowType.home_loan.name)
                });
                ctr.reviewProductIdx = -1;
                ctr.allLenders = [];
                ctr.residentialLenders = [];
                ctr.assetFinanceLenders = [];
                ctr.personalLenders = [];
                ctr.lenders = [];
                ctr.documents = [];
                ctr.maximumBorrowingData = [];
                ctr.numberOfApplicants = 0;
                ctr.maximumBorrowing = {
                  key: 'quickToolMaximumBorrowing',
                  lvr: 0,
                  amount: 0,
                  useLmi: false,
                  useGeneric: false,
                  contacts: [],
                  expenses: []
                };

                ctr.validateRequiredFields = () => {
                  if (ctr.maximumBorrowing.contacts.length) {
                    return _.every(
                      ctr.maximumBorrowing.contacts,
                      (c) => c?.employmentType?.name !== ContactEmploymentType.none.name
                    );
                  }
                  return false;
                };

                $q.all([
                  organizationService.readOrganization({ id: ctr.currentOrganization?.id }),
                  accountService.readAccount({ id: $rootScope.CurrentAccount?.id }),
                  lendersService.getAvailable({
                    cca2: [ctr.organizationCountry.cca2]
                  })
                ]).then((data) => {
                  const organization = data[0];
                  const account = data[1];
                  const lenders = data[2];
                  ctr.currentAccount = account;
                  ctr.isBroker = authenticationService.isBroker(ctr.currentAccount?.id);

                  if (lenders?.length) {
                    ctr.allLenders = lenders;
                    ctr.residentialLenders = _.filter(
                      lenders || [],
                      (l) => l.type.indexOf('RESIDENTIAL') > -1
                    );
                    ctr.residentialLenders = _.chain(ctr.residentialLenders)
                      .sortNatural('name')
                      .value();
                    ctr.assetFinanceLenders = _.filter(
                      lenders || [],
                      (l) => l.type.indexOf('ASSET_FINANCE') > -1
                    );
                    ctr.assetFinanceLenders = _.chain(ctr.assetFinanceLenders)
                      .sortNatural('name')
                      .value();
                    ctr.personalLenders = _.filter(
                      lenders || [],
                      (l) => l.type.indexOf('PERSONAL') > -1
                    );
                    ctr.personalLenders = _.chain(ctr.personalLenders)
                      .sortNatural('name')
                      .value();
                  }
                  if (
                    ctr.residentialLenders.length &&
                    ctr.currentAccount?.lenderAccreditations?.length
                  ) {
                    ctr.lenders = getAvailableLendersByLenderCommissions(
                      ctr.residentialLenders,
                      organization,
                      ctr.currentAccount,
                      ctr.workflow,
                      ctr.isEnterprise,
                      false
                    );
                  }
                  ctr.hasHomeLoanTools =
                    ctr.hasBrokerToolsEnabled && ctr.isBroker && ctr.lenders.length;
                  ctr.isReady = true;

                  if (ctr.lenders.length) {
                    const idLenders = _.map(ctr.lenders, 'id');
                    lendersService
                      .getDocuments({ idLenders, types: ['LOGO'] })
                      .then((lendersDocuments) => {
                        if (lendersDocuments && lendersDocuments.length) {
                          ctr.documents = lendersDocuments;
                        }
                      });
                  }

                  ctr.availableApplicants = homeLoanService.getAvailableApplicants();
                  ctr.availableContactResidentialStatusOptions = ContactResidentialStatusOption.available();
                  ctr.availableIncomeLastTaxYears = helperService.getAvailableIIncomeLastTaxYears();
                  ctr.availableIncomePreviousTaxYears = helperService.getAvailableIIncomePreviousTaxYears();
                  ctr.availableLiabilityTypes = liabilitiesService.getAllLiabilityTypes();
                  ctr.availableTermInMonthsShownInYears = helperService.getAvailableTermInMonthsShownInYears(
                    { isRegular: true }
                  );
                  ctr.availableContactEmploymentTypes = ContactEmploymentType.available();
                  ctr.availableEmploymentBasis = [];

                  ctr.contact = () => ({
                    key: '',
                    keySpouse: '',
                    state: '',
                    postalCode: '',
                    married: false,
                    dependents: 0,
                    totalIncomeGrossSalary: 0,
                    totalIncomeAllowance: 0,
                    totalIncomeBonus: 0,
                    totalIncomeCommissions: 0,
                    totalIncomeOvertimeEssential: 0,
                    totalIncomeOvertimeNonEssential: 0,
                    totalIncomeRental: 0,
                    totalIncomeRentalProperties: 0,
                    totalIncomeBoarder: 0,
                    totalIncomeBoarderNumberOfBoarders: 0,
                    totalIncomeBoarderAllInclusive: false,
                    totalIncomeOtherTaxable: 0,
                    totalIncomeNonTaxable: 0,
                    totalIncomeBusinessLastTaxYear: 0,
                    totalIncomeBusinessPreviousTaxYear: 0,
                    totalInterestAndOtherAddBacksLastTaxYear: 0,
                    totalInterestAndOtherAddBacksPreviousTaxYear: 0,
                    totalProfitBeforeTaxLastTaxYear: 0,
                    totalProfitBeforeTaxPreviousTaxYear: 0,
                    totalDepreciationLastTaxYear: 0,
                    totalDepreciationPreviousTaxYear: 0,
                    liabilitiesCreditCards: [],
                    liabilitiesOverdraft: [],
                    liabilitiesMortgage: [],
                    liabilitiesPersonal: [],
                    liabilitiesVehicle: [],
                    liabilitiesOther: [],
                    liabilitiesProposed: [
                      {
                        key: 'quickToolLiabilitiesProposed',
                        isInvestment: false,
                        repayment: 0,
                        interestRate: 0,
                        revertRate: 0,
                        balance: 0,
                        termIo: 0,
                        term: 0,
                        ownership: 0
                      }
                    ],
                    hasEducationDebt: false,
                    isSelfEmployedInACompany: false,
                    postSettlementAddressStatus: false,
                    purchaseOwnerOccupiedStatus: true,
                    housing: ContactResidentialStatusOption.none,
                    employmentType: ContactEmploymentType.none,
                    employmentBasis: ContactEmploymentBasis.none
                  });

                  ctr.liability = () => ({
                    key: '',
                    isInvestment: false,
                    isRefinanced: false,
                    lenderAbbr: '',
                    repayment: 0,
                    interestRate: 0,
                    balance: 0,
                    limit: 0,
                    termIo: 0,
                    term: 0
                  });

                  ctr.expense = () => ({
                    key: 'householdExpenses',
                    idContacts: [],
                    foodAndSupermarket: 0,
                    coffeesLunchesTakeaway: 0,
                    entertainment: 0,
                    domesticHolidays: 0,
                    gymFeesSportOtherHealthAndWellness: 0,
                    cigarettesAndAlcohol: 0,
                    clothingShoesAndAccessories: 0,
                    hairdressingAndGrooming: 0,
                    phoneInternetAndPayTv: 0,
                    mediaStreamingAndSubscriptionServices: 0,
                    giftsAndCelebrations: 0,
                    otherDiscretionaryExpenses: 0,
                    recreationalVehicleRunningCosts: 0,
                    pets: 0,
                    publicEducationCosts: 0,
                    privateEducationCosts: 0,
                    tertiaryAndVocationalEducation: 0,
                    childcare: 0,
                    childOrSpousalMaintenance: 0,
                    privateHealthInsurance: 0,
                    doctorDentistPharmacyGlasses: 0,
                    lifeTraumaIncomeInsurance: 0,
                    essentialVehicleRunningCost: 0,
                    publicTransportTaxisAndRideShareCommutingAirfares: 0,
                    essentialVehicleInsurance: 0,
                    currentRentExpense: 0,
                    ongoingBoardExpense: 0,
                    primaryResidenceRunningCosts: 0,
                    primaryResidenceBodyCorp: 0,
                    secondaryResidenceRunningCosts: 0,
                    secondaryResidenceBodyCorp: 0,
                    investmentPropertyRunningCosts: 0,
                    investmentPropertyBodyCorp: 0
                  });

                  ctr.canCalculate = () => {
                    const hasAnyEmptyFieldOfEmploymentType = _.some(
                      ctr.maximumBorrowing.contacts,
                      (c) => c.employmentType?.name === ContactEmploymentType.none.name
                    );
                    return ctr.numberOfApplicants > 0 && !hasAnyEmptyFieldOfEmploymentType;
                  };

                  ctr.isValidPostCode = (postCode, cca2) => {
                    if (cca2 === 'AU' || cca2 === 'NZ') {
                      return /\b(\d{4})\b/.test(postCode) && String(postCode).length === 4;
                    }
                    return true;
                  };

                  ctr.showContactWarning = (idx) => {
                    const contact = ctr.maximumBorrowing.contacts[idx];
                    const collections = [];
                    if (ctr.organizationCountry.cca2 === 'AU') {
                      collections.push(contact.state !== '');
                    }
                    collections.push(contact.postalCode !== '');
                    collections.push(
                      contact.housing.name !== ContactResidentialStatusOption.none.name
                    );
                    if (
                      contact.employmentType?.name ===
                      ContactEmploymentType.salaried_employee.name
                    ) {
                      collections.push(contact.totalIncomeGrossSalary > 0);
                    }
                    if (
                      contact.employmentType?.name === ContactEmploymentType.self_employed.name
                    ) {
                      if (ctr.organizationCountry.cca2 === 'NZ') {
                        collections.push(
                          contact.totalProfitBeforeTaxLastTaxYear > 0,
                          contact.totalProfitBeforeTaxPreviousTaxYear > 0
                        );
                      } else {
                        collections.push(contact.totalProfitBeforeTaxLastTaxYear > 0);
                      }
                    }
                    return _.some(collections, (c) => c === false);
                  };

                  ctr.availableSpouses = [
                    { key: 'notInApplication', value: 'Not in application' }
                  ];

                  ctr.householdAdd = () => {
                    ctr.maximumBorrowing.expenses.push(ctr.expense());
                  };

                  ctr.householdRemove = ({ idx }) => {
                    ctr.maximumBorrowing.expenses.splice(idx, 1);
                  };

                  ctr.getTabTitle = ({ household }) => {
                    let title = '-';
                    if (household?.key) {
                      title = household?.idContacts?.length
                        ? `Household of ${_.map(
                            _.filter(
                              ctr.maximumBorrowing?.contacts,
                              (c) => household?.idContacts.indexOf(c?.key) > -1
                            ),
                            (h) => ctr.getContactName({ key: h?.key })
                          ).join(' and ')}`
                        : 'Please choose contact(s)';
                    }
                    return title;
                  };

                  ctr.changeContacts = ({ household }) => {
                    const hhd = household;
                    if (hhd?.idContacts?.length > 2) {
                      hhd.idContacts = ctr.prevModel;
                    } else {
                      ctr.prevModel = hhd?.idContacts;
                    }
                  };

                  ctr.isContactSelected = ({ idContact, idContacts }) => {
                    const idExpensesContacts = _.flatten(
                      _.compact(_.map(ctr.maximumBorrowing.expenses, 'idContacts'))
                    );
                    const idHouseholdContacts = _.difference(idExpensesContacts, idContacts);
                    if (idHouseholdContacts?.indexOf(idContact) === -1) {
                      return false;
                    }
                    return true;
                  };

                  ctr.toggleApplicants = () => {
                    if (ctr.numberOfApplicants) {
                      let start = 0;
                      let len = 0;
                      let isAdding = false;
                      if (ctr.maximumBorrowing.contacts.length !== ctr.numberOfApplicants) {
                        if (ctr.maximumBorrowing.contacts.length === 0) {
                          start = 0;
                          len = ctr.numberOfApplicants;
                          isAdding = true;
                        } else if (
                          ctr.maximumBorrowing.contacts.length > 0 &&
                          ctr.maximumBorrowing.contacts.length < ctr.numberOfApplicants
                        ) {
                          start = ctr.maximumBorrowing.contacts.length;
                          len = ctr.numberOfApplicants;
                          isAdding = true;
                        } else if (
                          ctr.maximumBorrowing.contacts.length > 0 &&
                          ctr.maximumBorrowing.contacts.length > ctr.numberOfApplicants
                        ) {
                          start = ctr.numberOfApplicants;
                          len = ctr.maximumBorrowing.contacts.length;
                          isAdding = false;
                        }
                        for (let a = start; a < len; a += 1) {
                          if (isAdding) {
                            const contact = ctr.contact();
                            contact.key = `applicant${a + 1}`;
                            ctr.maximumBorrowing.contacts.push(contact);
                            ctr.availableSpouses.push({
                              key: `applicant${a + 1}`,
                              value: `Applicant ${a + 1}`
                            });
                          } else {
                            const key = `applicant${a + 1}`;
                            const idx = ctr.findIndexById(ctr.maximumBorrowing.contacts, key);
                            if (idx > -1) {
                              helperService.removeItemFromArray(
                                ctr.maximumBorrowing.contacts,
                                idx
                              );
                            }
                            const mIdx = ctr.findIndexById(ctr.availableSpouses, key);
                            if (mIdx > -1) {
                              helperService.removeItemFromArray(ctr.availableSpouses, mIdx);
                            }
                          }
                        }
                      }
                    } else {
                      ctr.maximumBorrowing = {
                        key: 'quickToolMaximumBorrowing',
                        lvr: 0,
                        useLmi: false,
                        useGeneric: false,
                        amount: 0,
                        contacts: [],
                        expenses: []
                      };
                    }
                  };

                  ctr.getContactName = ({ key }) => key?.capitalizeFirstLetter() || 'N/A';

                  ctr.findIndexById = (array, id) => array.findIndex((item) => item.key === id);

                  ctr.removeCurrentApplicant = (idApplicant) => (item) => {
                    if (item.key === idApplicant) {
                      return false;
                    }
                    return true;
                  };

                  ctr.filteredSpouses = (sIdx) =>
                    ctr.availableSpouses.filter(
                      (spouse) =>
                        !_.find(ctr.maximumBorrowing.contacts, (contact, idx) => {
                          if (sIdx === idx) {
                            return false;
                          }
                          return contact.keySpouse === spouse.key;
                        })
                    );

                  ctr.toggleSpouse = (contact) => {
                    const sIdx = _.findIndex(
                      ctr.maximumBorrowing.contacts,
                      (c) => c.key === contact.keySpouse
                    );
                    if (sIdx > -1) {
                      ctr.maximumBorrowing.contacts[sIdx].married = true;
                      ctr.maximumBorrowing.contacts[sIdx].keySpouse = contact.key;
                    }
                  };

                  ctr.setResidentialStatus = (idx) => {
                    ctr.maximumBorrowing.contacts[idx].postSettlementAddressStatus =
                      ctr.maximumBorrowing.contacts[idx]?.housing?.name ===
                        ContactResidentialStatusOption.renting.name ||
                      ctr.maximumBorrowing.contacts[idx]?.housing?.name ===
                        ContactResidentialStatusOption.boarding.name;
                  };

                  ctr.toggleEmploymentType = (idx) => {
                    ctr.availableEmploymentBasis = helperService.getAvailableContactEmploymentBasis(
                      {
                        employmentType: ctr.maximumBorrowing.contacts[idx].employmentType
                      }
                    );
                    if (
                      ctr.maximumBorrowing.contacts[idx]?.employmentType?.name ===
                      ContactEmploymentType.self_employed.name
                    ) {
                      ctr.maximumBorrowing.contacts[idx].totalIncomeBusinessLastTaxYear =
                        ctr.availableIncomeLastTaxYears[0].value;
                      ctr.maximumBorrowing.contacts[idx].totalIncomeBusinessPreviousTaxYear =
                        ctr.availableIncomePreviousTaxYears[0].value;
                    }
                    ctr.setSelfEmployedStatus(idx);
                    ctr.toggleIncome(idx);
                  };

                  ctr.setSelfEmployedStatus = (idx) => {
                    ctr.maximumBorrowing.contacts[idx].isSelfEmployedInACompany =
                      ctr.maximumBorrowing.contacts[idx]?.employmentType?.name ===
                        ContactEmploymentType.self_employed.name &&
                      ctr.maximumBorrowing.contacts[idx]?.employmentBasis?.name ===
                        ContactEmploymentBasis.in_a_company.name;
                  };

                  ctr.changeTaxYear = (isLastTaxtYear, idx) => {
                    if (isLastTaxtYear) {
                      ctr.maximumBorrowing.contacts[idx].totalIncomeBusinessPreviousTaxYear =
                        ctr.maximumBorrowing.contacts[idx].totalIncomeBusinessLastTaxYear - 1;
                    } else {
                      ctr.maximumBorrowing.contacts[idx].totalIncomeBusinessLastTaxYear =
                        ctr.maximumBorrowing.contacts[idx].totalIncomeBusinessPreviousTaxYear +
                        1;
                    }
                  };

                  ctr.toggleIncome = (idx) => {
                    if (
                      ctr.maximumBorrowing.contacts[idx]?.employmentType?.name ===
                        ContactEmploymentType.salaried_employee.name ||
                      ctr.maximumBorrowing.contacts[idx]?.employmentType?.name ===
                        ContactEmploymentType.retired.name ||
                      ctr.maximumBorrowing.contacts[idx]?.employmentType?.name ===
                        ContactEmploymentType.unemployed.name
                    ) {
                      ctr.maximumBorrowing.contacts[idx].totalIncomeBusinessLastTaxYear = 0;
                      ctr.maximumBorrowing.contacts[idx].totalIncomeBusinessPreviousTaxYear = 0;
                      ctr.maximumBorrowing.contacts[
                        idx
                      ].totalInterestAndOtherAddBacksLastTaxYear = 0;
                      ctr.maximumBorrowing.contacts[
                        idx
                      ].totalInterestAndOtherAddBacksPreviousTaxYear = 0;
                      ctr.maximumBorrowing.contacts[idx].totalProfitBeforeTaxLastTaxYear = 0;
                      ctr.maximumBorrowing.contacts[
                        idx
                      ].totalProfitBeforeTaxPreviousTaxYear = 0;
                      ctr.maximumBorrowing.contacts[idx].totalDepreciationLastTaxYear = 0;
                      ctr.maximumBorrowing.contacts[idx].totalDepreciationPreviousTaxYear = 0;
                    }
                    if (
                      ctr.maximumBorrowing.contacts[idx]?.employmentType?.name ===
                        ContactEmploymentType.retired.name ||
                      ctr.maximumBorrowing.contacts[idx]?.employmentType?.name ===
                        ContactEmploymentType.unemployed.name
                    ) {
                      ctr.maximumBorrowing.contacts[idx].totalIncomeGrossSalary = 0;
                      ctr.maximumBorrowing.contacts[idx].totalIncomeAllowance = 0;
                      ctr.maximumBorrowing.contacts[idx].totalIncomeBonus = 0;
                      ctr.maximumBorrowing.contacts[idx].totalIncomeCommissions = 0;
                      ctr.maximumBorrowing.contacts[idx].totalIncomeOvertimeEssential = 0;
                      ctr.maximumBorrowing.contacts[idx].totalIncomeOvertimeNonEssential = 0;
                    }
                  };

                  ctr.liabilityAdd = (liabilityType, idx) => {
                    const liability = ctr.liability();
                    if (liabilityType.id === ctr.availableLiabilityTypes[0].id) {
                      ctr.maximumBorrowing.contacts[idx].liabilitiesMortgage.push(liability);
                    } else if (liabilityType.id === ctr.availableLiabilityTypes[1].id) {
                      ctr.maximumBorrowing.contacts[idx].liabilitiesCreditCards.push(liability);
                    } else if (liabilityType.id === ctr.availableLiabilityTypes[2].id) {
                      ctr.maximumBorrowing.contacts[idx].liabilitiesOverdraft.push(liability);
                    } else if (liabilityType.id === ctr.availableLiabilityTypes[3].id) {
                      ctr.maximumBorrowing.contacts[idx].liabilitiesVehicle.push(liability);
                    } else if (liabilityType.id === ctr.availableLiabilityTypes[4].id) {
                      ctr.maximumBorrowing.contacts[idx].liabilitiesPersonal.push(liability);
                    } else if (liabilityType.id === ctr.availableLiabilityTypes[7].id) {
                      ctr.maximumBorrowing.contacts[idx].liabilitiesOther.push(liability);
                    }
                  };

                  ctr.liabilityDelete = (liabilityType, cIdx, lIdx) => {
                    if (liabilityType.id === ctr.availableLiabilityTypes[0].id) {
                      ctr.maximumBorrowing.contacts[cIdx].liabilitiesMortgage.splice(lIdx, 1);
                    } else if (liabilityType.id === ctr.availableLiabilityTypes[1].id) {
                      ctr.maximumBorrowing.contacts[cIdx].liabilitiesCreditCards.splice(
                        lIdx,
                        1
                      );
                    } else if (liabilityType.id === ctr.availableLiabilityTypes[2].id) {
                      ctr.maximumBorrowing.contacts[cIdx].liabilitiesOverdraft.splice(lIdx, 1);
                    } else if (liabilityType.id === ctr.availableLiabilityTypes[3].id) {
                      ctr.maximumBorrowing.contacts[cIdx].liabilitiesVehicle.splice(lIdx, 1);
                    } else if (liabilityType.id === ctr.availableLiabilityTypes[4].id) {
                      ctr.maximumBorrowing.contacts[cIdx].liabilitiesPersonal.splice(lIdx, 1);
                    } else if (liabilityType.id === ctr.availableLiabilityTypes[7].id) {
                      ctr.maximumBorrowing.contacts[cIdx].liabilitiesOther.splice(lIdx, 1);
                    }
                  };

                  ctr.setLiabilityKey = (currentLiability) => {
                    const liability = currentLiability;
                    liability.key = liability.lenderAbbr;
                  };

                  ctr.clearSearchTerm = () => {
                    ctr.searchTerm = '';
                  };

                  ctr.isAnyOfProductsHaveEmptyInterestOnlyTerm = () =>
                    _.some(ctr.reviewProducts, (productReview) =>
                      _.some(
                        productReview.productSplits,
                        (productSplit) =>
                          homeLoanService.isProductIO({ product: productSplit }) &&
                          !productSplit.interestOnlyTerm
                      )
                    );

                  ctr.productSplitAdd = (productSplitData) => {
                    ctr.idReviewProduct = productSplitData?.idReviewProduct || '';
                    ctr.searchFields = productSplitData?.searchFields || ctr.searchFields;
                    ctr.isSplitSearch = true;
                    ctr.showSection('search');
                  };

                  ctr.productsSelected = (product) => {
                    const rIdx = _.findIndex(
                      ctr.reviewProducts || [],
                      (p) => p?.id === ctr.idReviewProduct
                    );
                    if (rIdx > -1 && !_.isEmpty(product)) {
                      const [
                        reviewProductSplit,
                        compareProductSplit
                      ] = homeLoanService.addProductToSplits({
                        selectedProduct: product
                      });
                      if (!_.isEmpty(reviewProductSplit) && !_.isEmpty(compareProductSplit)) {
                        ctr.reviewProducts[rIdx].productSplits.push(reviewProductSplit);
                        ctr.compareProducts[rIdx].productSplits.push(compareProductSplit);
                        let absLendingPurposeCode;
                        const sIdx = ctr.reviewProducts[rIdx]?.productSplits?.length - 1;
                        const rLen = ctr.reviewProducts?.length || 0;
                        for (let r = 0; r < rLen; r += 1) {
                          if (
                            !absLendingPurposeCode &&
                            ctr.reviewProducts[r]?.productSplits[sIdx]?.absLendingPurposeCode
                              ?.id
                          ) {
                            absLendingPurposeCode =
                              ctr.reviewProducts[r]?.productSplits[sIdx]?.absLendingPurposeCode;
                          }
                        }
                        if (absLendingPurposeCode) {
                          ctr.reviewProducts[rIdx].productSplits[
                            sIdx
                          ].absLendingPurposeCode = absLendingPurposeCode;
                          ctr.compareProducts[rIdx].productSplits[
                            sIdx
                          ].absLendingPurposeCode = absLendingPurposeCode;
                        }
                        ctr.saveReviewLoanProducts();
                      }
                    }
                    ctr.isSplitSearch = false;
                    ctr.showSection('review');
                  };

                  ctr.updateChosenProducts = (reviewProducts) => {
                    const idProducts = [];
                    for (let r = 0; r < reviewProducts.length; r += 1) {
                      if (
                        _.indexOf(
                          idProducts,
                          reviewProducts[r]?.productSplits[0]?.idProduct
                        ) === -1
                      ) {
                        idProducts.push(reviewProducts[r].productSplits[0].idProduct);
                      }
                    }
                    if (idProducts.length) {
                      const idx = ctr.chosenProducts.findIndex(
                        (c) => idProducts.indexOf(c.id) === -1
                      );
                      if (idx > -1) {
                        ctr.chosenProducts.splice(idx, 1);
                      }
                    }
                  };

                  ctr.updateReviewAndCompareProducts = (editedData) => {
                    if (!_.isEmpty(editedData?.searchFields)) {
                      const searchFields = HomeLoanSearchProduct.Build(editedData.searchFields);
                      ctr.searchFields = searchFields;
                    }
                    if (editedData?.reviewProducts) {
                      const reviewProducts = _.map(
                        _.compact(editedData.reviewProducts),
                        (reviewProduct) => ReviewProduct.Build(reviewProduct)
                      );
                      ctr.reviewProducts = reviewProducts;
                    }
                    if (editedData?.compareProducts) {
                      const compareProducts = _.map(
                        _.compact(editedData.compareProducts),
                        (compareProduct) => CompareProduct.Build(compareProduct)
                      );
                      ctr.compareProducts = compareProducts;
                    }
                  };

                  ctr.saveSearchLoanProducts = (editedData) => {
                    ctr.updateReviewAndCompareProducts(editedData);
                    if (!_.isEmpty(editedData)) {
                      ctr.saveChanges(editedData);
                    }
                  };

                  ctr.saveReviewLoanProducts = (editedData) => {
                    ctr.updateReviewAndCompareProducts(editedData);
                    if (!_.isEmpty(editedData)) {
                      ctr.saveChanges(editedData);
                    }
                  };

                  ctr.saveCompareLoanProducts = (editedData) => {
                    if (editedData?.reviewProducts) {
                      const reviewProducts = _.map(
                        _.compact(editedData.reviewProducts),
                        (reviewProduct) => ReviewProduct.Build(reviewProduct)
                      );
                      ctr.reviewProducts = reviewProducts;
                    }
                    if (editedData?.compareProducts) {
                      const compareProducts = _.map(
                        _.compact(editedData.compareProducts),
                        (compareProduct) => CompareProduct.Build(compareProduct)
                      );
                      ctr.compareProducts = compareProducts;
                    }
                    if (!_.isEmpty(editedData)) {
                      ctr.saveChanges(editedData);
                    }
                  };

                  ctr.saveChanges = (editedData) => {
                    const hLCD = editedData?.hLCD || '';
                    $timeout(() => {
                      eventService.changedData({ changedData: hLCD });
                    }, 1000);
                  };

                  ctr.showSection = (section) => {
                    ctr.activeSection = section;
                  };

                  ctr.createPdf = (isView) => {
                    if (isView) {
                      ctr.isViewPreparing = true;
                    } else {
                      ctr.isDownloadPreparing = true;
                    }
                    pdfService
                      .createPdf({
                        compareProducts: ctr.compareProducts,
                        reviewProducts: ctr.reviewProducts,
                        lenders: ctr.lenders,
                        documents: ctr.documents,
                        searchFields: ctr.searchFields,
                        pdfType: helperService.getAvailablePdfTypes()[4],
                        isQuickTool: true,
                        isView
                      })
                      .then(() => {
                        if (isView) {
                          ctr.isViewPreparing = false;
                        } else {
                          ctr.isDownloadPreparing = false;
                        }
                      });
                  };
                });
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then(() => {
              //
            });
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
